import { css, Theme } from "@emotion/react";
import { Z_INDICES } from "./consts";

export const globalStyles = (theme: Theme) => css`
  * {
    letter-spacing: -0.04em;
    font-family: "Work Sans", "sans-serif";
  }

  *,
  ::after,
  ::before {
    box-sizing: border-box;
  }
  html {
    min-height: 100%;
    background-color: ${theme.theme["200"]};
  }

  body {
    margin: 0;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #f1f3f3;
  }

  a,
  button {
    all: unset;
    box-sizing: border-box;
  }

  button:not([disabled]),
  a {
    cursor: pointer;
  }

  input[type="number"] {
    appearance: textfield;
    -moz-appearance: textfield;
  }

  @media (prefers-reduced-motion: no-preference) {
    :root {
      scroll-behavior: smooth;
    }
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0;
  }
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  ::-webkit-scrollbar-thumb {
    background: ${theme.theme["900"]};
    border-radius: 10px;
  }

  .ant-drawer {
    z-index: ${Z_INDICES.CONTENT_SURFACE};
  }
`;
